import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ModalKeyboardDirective } from '../modal-keyboard/modal-keyboard.directive';

@Component({
  selector: 'lib-confirm-edit-modal',
  standalone: true,
  imports: [ModalKeyboardDirective],
  template: `
    @if (isOpen) {
      <div class="confirm-edit-modal__backdrop" (click)="cancel.emit()">
        <div
          class="confirm-edit-modal__container"
          (click)="$event.stopPropagation()"
          [libModalKeyboard]="true"
          [libModalKeyboardCanSubmit]="false"
          (libModalKeyboardCancel)="cancel.emit()"
        >
          <h3 class="confirm-edit-modal__title">{{ title }}</h3>

          @if (metaPrimaryLabel || metaSecondaryLabel) {
            <div class="confirm-edit-modal__meta">
              @if (metaPrimaryLabel) {
                <div><strong>{{ metaPrimaryLabel }}:</strong> {{ metaPrimaryValue }}</div>
              }
              @if (metaSecondaryLabel) {
                <div><strong>{{ metaSecondaryLabel }}:</strong> {{ metaSecondaryValue }}</div>
              }
            </div>
          }

          <label class="confirm-edit-modal__label">
            {{ confirmLabel }}
            <input
              type="text"
              data-modal-primary-focus="true"
              [value]="confirmValue"
              (input)="onConfirmInput($event)"
              [placeholder]="confirmPlaceholder"
            />
          </label>

          <ng-content></ng-content>
        </div>
      </div>
    }
  `,
  styles: [`
    .confirm-edit-modal__backdrop {
      position: fixed;
      inset: 0;
      background: rgba(17, 24, 39, 0.45);
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 16px;
      z-index: 1000;
    }

    .confirm-edit-modal__container {
      width: 100%;
      max-width: 640px;
      background: #ffffff;
      border-radius: 12px;
      border: 1px solid #e5e7eb;
      padding: 16px;
      box-sizing: border-box;
    }

    .confirm-edit-modal__title {
      margin: 0 0 10px;
      color: #111827;
    }

    .confirm-edit-modal__meta {
      margin-bottom: 12px;
      color: #374151;
      font-size: 13px;
      display: grid;
      gap: 4px;
    }

    .confirm-edit-modal__label {
      display: flex;
      flex-direction: column;
      gap: 6px;
      margin-bottom: 12px;
      font-size: 13px;
      color: #374151;
      font-weight: 600;
    }
    .confirm-edit-modal__label:focus-within {
      color: #1d4ed8;
    }

    .confirm-edit-modal__label input {
      height: 40px;
      border: 1px solid #d1d5db;
      border-radius: 8px;
      padding: 0 10px;
      box-sizing: border-box;
    }
    .confirm-edit-modal__container :is(button, input, select, textarea):focus-visible,
    .confirm-edit-modal__container :is(button, input, select, textarea):focus {
      outline: 2px solid #2563eb;
      outline-offset: 2px;
    }
    .confirm-edit-modal__container :is(input, select, textarea):focus-visible,
    .confirm-edit-modal__container :is(input, select, textarea):focus {
      border-color: #2563eb;
      box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
      outline: none;
    }
  `],
})
export class ConfirmEditModalComponent {
  @Input() isOpen = false;
  @Input() title = 'Edit';
  @Input() metaPrimaryLabel = '';
  @Input() metaPrimaryValue = '';
  @Input() metaSecondaryLabel = '';
  @Input() metaSecondaryValue = '';
  @Input() confirmLabel = 'Confirm to unlock editing';
  @Input() confirmPlaceholder = '';
  @Input() confirmValue = '';

  @Output() cancel = new EventEmitter<void>();
  @Output() confirmValueChange = new EventEmitter<string>();

  protected onConfirmInput(event: Event): void {
    const target = event.target as HTMLInputElement | null;
    this.confirmValueChange.emit(target?.value ?? '');
  }
}
